export const KDP_UX_COMPONENT_ESPOT = 'KDP-UXcomponent';
export const KDP_CROSS_SELL_ESPOT = 'KDP-CrossSell';
